import { useState } from "react";
import "./join-us.css";
import FirstView from "./first-view.js";
import SecondView from "./second-view.js";
import ThirdView from "./third-view.js";
import Footer from "../footer/footer.js";
import { ToastContainer } from "react-toastify";
import { handleError, handleSuccess } from "../../utils.js";
import logo from "../../assets/wjcwadmin-logo.png";

const JoinUs = () => {
  const [isCurrentView, setIsCurrentView] = useState(1);

  const [sponsorName, setSponsorName] = useState("");
  // Shared form data state
  const [formData, setFormData] = useState({
    member_id: "",
    token: "",
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    address: "",
    city: "",
    zip: "",
  });



  // Handle "Next" button click
  const handleNext = () => {
    setIsCurrentView((prev) => prev + 1); // Move to the next step 
  };
  if (isCurrentView == 4) {
    setIsCurrentView(1);
  }

  return (
    <>
      <div className="header join-us-header">
        <img src={logo} alt="Logo" className="logo join-us-logo" />
      </div>
      {isCurrentView === 1 && (
        <FirstView
          setSponsorName={setSponsorName}
          formData={formData}
          setData={setFormData}
          handleNext={handleNext}
        />
      )}
      {isCurrentView === 2 && (
        <SecondView
          formData={formData}
          setData={setFormData}
          handleNext={handleNext}
        />
      )}
      {isCurrentView === 3 && (
        <ThirdView
          sponsorName={sponsorName}
          formData={formData}
          setData={setFormData}
          handleNext={handleNext}
        />
      )}
      <Footer />
    </>
  );
};

export default JoinUs;
